import React from "react";
import { Link } from "react-router-dom";

interface LockedPageProps {
  content: string;
}
const LockedPage = ({ content }: LockedPageProps) => {
  return (
    <div className="flex justify-center ">
      <div className="text-center mt-14">
        <img src={"/icons/Warning.png"} alt="Centered Content" className="mx-auto mb-4" />
        <p className="text-sm text-gray-400 w-[200px]">
          Complete onboarding in{" "}
          <Link to={"../channels/onboarding/"} className="font-bold ">
            Channel{" "}
          </Link>
          tab to {content}.
        </p>
      </div>
    </div>
  );
  //
};

export default LockedPage;
